import React from "react";
import { MdSearch } from "react-icons/md";

// The search card at the top of the Hajex Network and My Carrier Accounts tabs.
const SearchToolbar = ({ value, onChange, placeholder, children }) => (
  <div className="flex flex-wrap items-center gap-2.5 rounded-[10px] border border-ui-border bg-ui-surface px-3 py-2.5">
    <label className="flex flex-[1_1_220px] items-center gap-[7px] rounded-lg border border-ui-border bg-ui-surface px-[11px] py-2 focus-within:shadow-[0_0_0_2px_var(--color-brand)] sm:max-w-[300px] sm:py-1.5">
      <MdSearch className="h-4 w-4 shrink-0 text-ui-text-subtle" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="min-w-0 flex-1 border-none bg-transparent p-0 text-[13px] text-ui-text outline-none placeholder:text-ui-text-subtle"
      />
    </label>
    {children}
  </div>
);

export default SearchToolbar;
